// extracted by mini-css-extract-plugin
export default {"loader":"UiLoader_loader__lnweg","shadow":"UiLoader_shadow__HWfwP"};